import logo from '../assets/logo.png';

function Footer() {
  return (
    <footer className="bg-navy-dark pt-16">
      <div className="wrap grid grid-cols-1 gap-x-10 gap-y-8 border-b border-white/10 pb-12 min-[521px]:grid-cols-2 min-[861px]:grid-cols-4 min-[861px]:gap-y-10">
        <div>
          <img
            src={logo}
            alt="Venus Solutions"
            className="mb-4 h-[30px] opacity-90 [filter:brightness(0)_invert(1)]"
          />
          <p className="max-w-[320px] text-[0.9rem] text-white/55">
            We build websites and apps for businesses, and our own products —
            including Invyntra, our inventory management platform.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <h4 className="footer-heading">Site</h4>
          <a href="#home" className="footer-link">
            Home
          </a>
          <a href="#services" className="footer-link">
            Services
          </a>
          <a href="#products" className="footer-link">
            Products
          </a>
          <a href="#about" className="footer-link">
            About
          </a>
          <a href="#contact" className="footer-link">
            Contact
          </a>
        </div>

        <div className="flex flex-col gap-3">
          <h4 className="footer-heading">Products</h4>
          <a href="https://invyntra.in" target="_blank" rel="noopener noreferrer" className="footer-link">
            Invyntra
          </a>
          <a href="#products" className="footer-link">
            Scholl OS (Coming Soon)
          </a>
        </div>

        <div className="flex flex-col gap-3">
          <h4 className="footer-heading">Contact</h4>
          <a href="mailto:venus.solutions95@gmail.com" className="footer-link">
            venus.solutions95@gmail.com
          </a>
        </div>
      </div>

      <div className="wrap py-6">
        <p className="text-[0.82rem] text-white/45">
          &copy; {new Date().getFullYear()} Venus Solutions Pvt Ltd. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
